export const referenceDataFileListSelector = ({
  referenceData
}) => referenceData;